export const SESSION_STATUS = Object.freeze({
    BOOTSTRAPPING: 'bootstrapping',
    ANONYMOUS: 'anonymous',
    AUTHENTICATED: 'authenticated',
});
